<template>
    <div>

        <div class="position-relative">
            <!-- shape Hero -->
            <section class="section-shaped my-0">
                <div class="shape shape-style-1 shape-default shape-skew">
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
                <div class="container shape-container d-flex">
                    <div class="col px-0">
                        <div class="row ">
                            <h2 class="office text-white">Microsoft Office 365 consulting and integration services.</h2>
                           <div class="col-md-9 "> 
                            
                                <p class="off_con text-white">Boost productivity, workflow, and business operations with InfomazeOne’s Office 365 cloud services and solutions.</p>
                               <!-- <p class="off_con  text-white">Being an end-to-end office 365 partner for the cloud productivity suite, we demonstrate our best-in-class capabilities. InfomazeOne offers a comprehensive layout that encourages organizations to move their IT workloads to the cloud effortlessly.</p>
                                <p class="off_con  text-white">Our Office 365 consultants possess deep expertise in Office 365 managed services that perfectly align with your organizational goals and strategies. We help enterprises in successfully maximizing their productivity and business value through our Office 365 consulting services.</p>-->
                        </div>
                        </div> 
                    </div>
                    <div class="col-md-6 order-lg-2 ml-lg-auto">
                        <div class="position-relative pl-md-5">
                            <img src="@/assets/office365.png" class="img-center img-fluid">
                        </div>
                    </div>
                </div>
            </section>
            <!-- 1st Hero Variation -->
        </div>
        
        <section class="section section-lg">
            <div class="container">
                <div class="row row-grid align-items-center">
                    <div class="col-md-6 order-md-2">
                        <img src="img/theme/why-work-with-smakintel.jpg" class="img-fluid floating">
                    </div>
                    <div class="col-md-6 order-md-1">
                        <div class="pr-md-5">
                            
                             
                            <p class="off_con">Being an end-to-end office 365 partner for the cloud productivity suite, we demonstrate our best-in-class capabilities.
                                 InfomazeOne offers a comprehensive layout that encourages organizations to move their IT workloads to the cloud effortlessly.</p>
                            
                        </div>
                    </div>
                </div>
            </div>
        </section>
       
        <section class="section section section-shaped my-0 overflow-hidden">
            <div class="shape shape-style-1 bg-gradient-warning shape-skew">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
            <div class="container py-0">
                <div class="row row-grid align-items-center">
                    <div class="col-md-6 order-lg-2 ml-lg-auto">
                        <div class="position-relative pl-md-5">
                            <img src="@/assets/Office2.png" class="img-center img-fluid">
                        </div>
                    </div>
                    <div class="col-lg-6 order-lg-1">
                        <div class="d-flex px-3">
                            
                            <div class="pl-4">
                                <p class="off_con text-white">Our Office 365 consultants possess deep expertise in Office 365 managed services that perfectly align with your organizational goals and strategies.
                                 We help enterprises in successfully maximizing their productivity and business value through our Office 365 consulting services.</p>
                            </div>
                        </div>
                       
                    </div>
                </div>
            </div>
        </section>
        
        <section class="section section-lg pt-0">
            <div class="container">
                <card gradient="warning"
                      no-body
                      shadow-size="lg"
                      class="border-0">
                    <div class="p-5">
                        <div class="row align-items-center">
                            <div class="col-lg-8">
                                <h3 class="text-white">Start Your Next Project with SMAKINTEL.</h3>
                                <p class="lead text-white mt-3">We will be the leader of a company that ends up being
                                    worth billions of dollars, because We got the solutions. We understand culture.</p>
                            </div>
                            <div class="col-lg-3 ml-lg-auto">
                                <base-button tag="a" href="/#/contact-us"
                                             type="white" block size="lg">
                                    Contact Us
                                </base-button>
                            </div>
                        </div>
                    </div>
                </card>
            </div>
        </section>
       
       

    </div>
</template>
<style>
.office_suites{
    font-size: 50px;
    padding-top: 10px;
    padding-bottom: 40px;
    color:white;
    font-weight:500;
;
}
.office{
    
    margin: 40px 0 0 0 ;
    padding-bottom:15px;
    font-size:35px;
}
.off_con{
    
    font-size: 1.25rem;
    font-weight:300;
    line-height: 1.7;
    margin-top: 1.5rem;
}

</style>


<script>
export default {
  name: "home",
  components: {}
};
</script>
